import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    FormControl,
    FormLabel,
    Input,
    Grid,
} from '@chakra-ui/react';
import CustomSelect from 'components/CustomSelect';

/**
 * ReminderModal - Reusable modal for setting reminders.
 * @param {object} props
 * @param {boolean} props.isOpen - Modal open state
 * @param {function} props.onClose - Close handler
 * @param {object} [props.value] - Reminder values {date, time, notify}
 * @param {function} [props.onChange] - Change handler for fields
 * @param {function} [props.onSet] - Handler for Set Reminder button
 */
function ReminderModal({ isOpen, onClose, value = {}, onChange, onSet }) {
    const notifyOptions = [
        { label: 'Email', value: 'email' },
        { label: 'SMS', value: 'sms' },
        { label: 'Push Notification', value: 'push' },
    ];
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
            <ModalOverlay />
            <ModalContent borderRadius="lg">
                <ModalHeader fontWeight="bold">Set Reminder</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Grid templateColumns={{ base: '1fr', md: '1fr 1fr' }} gap={6} mb={4}>
                        <FormControl>
                            <FormLabel>Date</FormLabel>
                            <Input
                                type="date"
                                name="date"
                                value={value.date || ''}
                                onChange={onChange}
                                placeholder="mm/dd/yyyy"
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabel>Time</FormLabel>
                            <Input
                                type="time"
                                name="time"
                                value={value.time || ''}
                                onChange={onChange}
                                placeholder="--:--"
                            />
                        </FormControl>
                    </Grid>
                    <FormControl mb={6}>
                        <FormLabel>Notify via</FormLabel>
                        <CustomSelect
                            name="notify"
                            options={notifyOptions}
                            placeholder="Select Option"
                            value={value.notify ?? ''}
                            onChange={(val) => {
                                onChange({ target: { name: 'notify', value: val?.target?.value } });
                            }}
                        />
                    </FormControl>
                </ModalBody>
                <ModalFooter>
                    <Button color="white" bg="#1b3b5f" mr={3} onClick={onSet}>
                        Set Reminder
                    </Button>
                    <Button color="#1b3b5f" bg="#B8C1D380" onClick={onClose}>
                        Cancel
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

export default ReminderModal;
